module.exports = __webpack_public_path__ + "static/media/W.026a0c23.png";